import React, { PropTypes, Component } from 'react';
import ReactGA from 'react-ga';
// import en from '../../../assets/images/leaderboard-en-ixia.jpg';
// import pt from '../../../assets/images/leaderboard-pt-ixia.jpg';
import en from '../../../assets/images/background-left-en-cards.png';
import pt from '../../../assets/images/background-left-pt-cards.png';


const propTypes = {
  locale: PropTypes.string.isRequired,
};

class Leaderboard extends Component {
  componentDidMount() {
    ReactGA.event({
      category: 'Ads',
      action: `Visualizou o Banner Rodapé (Leaderboard) da Ixia (${this.props.locale})`,
      opt_label: 'ixia, banner, leaderboard, view',
    });
  }

  render() {
    let img;
    switch (this.props.locale) {
      case 'pt':
        img = pt;
        break;
      default:
        img = en;
    }

    const handleClick = () => {
      ReactGA.event({
        category: 'Ads',
        action: `Clicou no Banner Rodapé (Leaderboard) da Ixia (${this.props.locale})`,
        opt_label: 'ixia, banner, leaderboard, click',
      });
    };

    const url = this.props.locale === 'es'
      ? 'https://www.ixiacom.com/es'
      : 'https://www.ixiacom.com/'
    ;

    return (
      <a
        onClick={handleClick}
        href={url}
        className="thirteen wide column"
        target="_blank"
        rel="noreferrer noopener"
      >
        <img src={img} alt="Rodapé" className="ui banner fluid image" />
      </a>
    );
  }
}


Leaderboard.propTypes = propTypes;

export default Leaderboard;



/** WEBPACK FOOTER **
 ** ./src/components/layout/ads/Leaderboard.js
 **/